<template>
    <div>
        <div v-show="parent2Show">
            <Form ref="formItem" :model="formItem" :rules="formValidate" style="max-width:600px" :label-width="100">
                <Form-item label="大区" prop="area">
                    <Input type="text" v-model="formItem.area" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="省份" prop="province">
                    <Input type="text" v-model="formItem.province" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="城市群" prop="citys">
                    <Input type="text" v-model="formItem.citys" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="地级市" prop="pcity">
                    <Input type="text" v-model="formItem.pcity" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="县级市" prop="ccity">
                    <Input type="text" v-model="formItem.ccity" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="一级门店类型" prop="firsttype">
                    <Input type="text" v-model="formItem.firsttype" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="二级门店类型" prop="secondtype">
                    <Input type="text" v-model="formItem.secondtype" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="三级门店类型" prop="thirdtype">
                    <Input type="text" v-model="formItem.thirdtype" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店编号" prop="scode">
                    <Input type="text" v-model="formItem.scode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店名称" prop="sname">
                    <Input type="text" v-model="formItem.sname" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店地址" prop="sloction">
                    <Input type="text" v-model="formItem.sloction" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="客户类型" prop="customertype">
                    <Input type="text" v-model="formItem.customertype" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="客户系列编号" prop="customercode">
                    <Input type="text" v-model="formItem.customercode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="客户系列" prop="customer">
                    <Input type="text" v-model="formItem.customer" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="业务员组织编码" prop="salesorganizecode">
                    <Input type="text" v-model="formItem.salesorganizecode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="业务员编码" prop="salesmancode">
                    <Input type="text" v-model="formItem.salesmancode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="业务员姓名" prop="salesmanname">
                    <Input type="text" v-model="formItem.salesmanname" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="上级主管编码" prop="supervisorcode">
                    <Input type="text" v-model="formItem.supervisor" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="上级主管" prop="supervisor">
                    <Input type="text" v-model="formItem.supervisor" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店负责人组织编码" prop="responorganizecode">
                    <Input type="text" v-model="formItem.responorganizecode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店负责人编码" prop="responcode">
                    <Input type="text" v-model="formItem.responcode" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="门店负责人" prop="responname">
                    <Input type="text" v-model="formItem.responname" placeholder="请输入"></Input>
                </Form-item>
                <Form-item label="类型" prop="stype">
                    <Input type="text" v-model="formItem.stype" placeholder="请输入"></Input>
                </Form-item>
                <Form-item>
                    <Button type="primary" @click="releaseFn('formItem')">提交</Button>
                </Form-item>
            </Form>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    export default {
        data(){
            return{
                formItem:{
                    stid:this.$route.query.stid,
                    area:null,
                    province:null,
                    citys:null,
                    pcity:null,
                    ccity:null,
                    firsttype:null,
                    secondtype:null,
                    thirdtype:null,
                    scode:null,
                    sname:null,
                    sloction:null,
                    customertype:null,
                    customercode:null,
                    customer:null,
                    salesorganizecode:null,
                    salesmancode:null,
                    salesmanname:null,
                    supervisor:null,
                    responorganizecode:null,
                    responcode:null,
                    responname:null,
                    stype:null,
                },
                formValidate:{                  //表单验证
                },
                dataOption:{
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 86400000;
                    }
                }
            }
        },
        watch:{
            $route(to,from){
                this.$store.dispatch('parent2ShowFn');
            }
        },
        computed: {
            parent2Show () {
                return this.$store.state.parent2Show;
            }
        },
        created(){
            this.$store.dispatch('parent2ShowFn');
            this.getData();
        },
        methods:{
            getData(){
                var _this=this;
                this.$http.get('/web/store/getStoreByStid',{
                    params:{
                        stid:_this.$route.query.stid
                    }
                }).then(function(res){
                    _this.formItem=res.data;
                    _this.$Message.success('加载成功');
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
            releaseFn(name){
                var _this=this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        delete _this.formItem['cdate'];
                        delete _this.formItem['aid'];
                        _this.formItem.stid=_this.$route.query.stid;
                        _this.$http.get('/web/store/updateStore',{
                            params:_this.formItem
                        }).then(function(res){
                            if(res.success){
                                _this.$Notice.success({
                                    title:'修改门店',
                                    desc:res.message,
                                });
                                _this.$router.push({path:'/store'});
                            }else{
                                _this.$Notice.error({
                                    title:'修改门店',
                                    desc:res.message,
                                });
                            }
                        }).catch(function(res){
                            _this.$Notice.success({
                                title:'修改门店',
                                desc:res.message,
                            });
                        })
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                })
            }
        }
    }
</script>
<style scoped>
.hdLiBox{ margin-bottom:20px; }
.hd_li p{ background:#f5f7f9; margin-bottom:5px;  line-height:50px; font-size:14px;}
.hd_li p span{ display:inline-block; width:100px; padding-left:10px; }

h3{ background:#464c5b; color:#fff; line-height:30px; padding-left:20px; }
</style>


// WEBPACK FOOTER //
// src/components/store/modifyStore.vue